import { Component, OnInit, Inject } from '@angular/core';
import { NoBillingReasonFilter } from '../../../model/billing/no-billing-reason-filter';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FilterService } from '../../../services/filter.service';
import { NotificationToastService } from '../../../services/notification-toast.service';

@Component({
  selector: 'app-no-billing-reason-dialog',
  templateUrl: './no-billing-reason-dialog.component.html',
  styleUrls: ['./no-billing-reason-dialog.component.css']
})
export class NoBillingReasonDialogComponent implements OnInit {

  form: FormGroup;
  noBillingReasons: NoBillingReasonFilter[] = [];

  constructor(
    public dialogRef: MatDialogRef<NoBillingReasonDialogComponent>,
    private filterService: FilterService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , @Inject(MAT_DIALOG_DATA) public data: any) {

    this.form = this.formBuilder.group({
      observations: [''],
      noBillingReason: [null, Validators.required]
    });
  }

  get f() { return this.form.controls; }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        this.dialogRef.close(<NoBillingReasonDialogResponse>this.form.getRawValue());
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'No facturar motivos');
    }
  }

  async ngOnInit() {
    try {
      this.noBillingReasons
       = await this.filterService.getNoBillingReasonFilter();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'No facturar motivos');
    }
  }
}


export class NoBillingReasonDialogResponse {
  noBillingReason: NoBillingReasonFilter;
  observations: string;
}
